export default __webpack_public_path__ + "static/media/powered-by.3e5e7da1.png";